import {
  layoutContainer,
  siteContentContainer,
  siteInnerContent,
} from "./styles";
import { ReactNode } from "react";
import "../../styles/global.scss";
import Footer from "./components/Footer";
import ToTop from "./components/ToTop";

const Layout = ({ children }: { children: ReactNode }) => {
  // const data = useStaticQuery(graphql`
  //   query SiteTitleQuery {
  //     site {
  //       siteMetadata {
  //         title
  //       }
  //     }
  //   }
  // `);

  return (
    <div css={layoutContainer}>
      <main>
        <div css={siteContentContainer}>
          <div css={siteInnerContent}>{children}</div>
        </div>
      </main>
      <ToTop />
      <Footer />
      <script async src="https://scripts.simpleanalyticscdn.com/latest.js"></script>
    </div>
  );
};

export default Layout;
